import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classcat from "classcat";
import { translate as t } from "../../../../infrastructure/translate/localization";
import { handlerAllowanceFormatted } from "../../../../infrastructure/allowance-config-repository";

class AllowanceEmployeeRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mealAmount: "",
      transportAmount: "",
      nurseryAmount: "",
    };
  }

  componentDidMount() {
    const { employeesItem } = this.props;
    this.setState({
      mealAmount: employeesItem.mealAmount,
      transportAmount: employeesItem.transportAmount,
      nurseryAmount: employeesItem.nurseryAmount,
    });
    window.addEventListener("keydown", this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    const { employeesItem } = this.props;
    if (prevProps.employeesItem !== employeesItem) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        mealAmount: employeesItem.mealAmount,
        transportAmount: employeesItem.transportAmount,
        nurseryAmount: employeesItem.nurseryAmount,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.target.blur();
    }
  };

  render() {
    const options = [];
    for (let i = 1; i <= 27; i += 1) {
      options.push(i);
    }

    const {
      employee,
      employeesItem,
      showMealBenefit,
      showTransportBenefit,
      showNurseryBenefit,
      handlerEditAllowance,
      totalAllowanceAmount,
      countryISO2Code,
    } = this.props;

    const { mealAmount, transportAmount, nurseryAmount } = this.state;

    return (
      <tr
        className={classcat([
          { "no-border": employee.error || employee.warning },
        ])}
        disabled={employee.state === "blocked"}
      >
        <td>{employee.internalId}</td>
        <td className="ellipsis-names ellipsis">{employee.nameAndSurnames}</td>
        <td hidden={!showMealBenefit}>
          <div className="cob-input-group short-group">
            <div className="cob-select">
              <select
                className="cob-select"
                onChange={(e) =>
                  handlerEditAllowance({
                    name: "mealDays",
                    value: e.target.value,
                  })
                }
                value={employeesItem.mealDays}
              >
                <option disabled>{t("working-days")}</option>
                {options.map((m) => (
                  <option defaultValue={m === 20} key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
              <FontAwesomeIcon icon="chevron-down" />
            </div>
          </div>
        </td>
        <td hidden={!showMealBenefit}>
          <div className="cob-input-group">
            <input
              placeholder={t("common-messages.amount")}
              type="number"
              onFocus={(event) => event.target.select()}
              onBlur={() => {
                const value = handlerAllowanceFormatted(
                  "mealAmount",
                  mealAmount,
                  countryISO2Code
                );
                handlerEditAllowance({ name: "mealAmount", value });
              }}
              value={mealAmount}
              onChange={(e) => this.setState({ mealAmount: e.target.value })}
            />
          </div>
        </td>
        <td hidden={!showTransportBenefit}>
          <div className="cob-input-group">
            <input
              placeholder={t("common-messages.amount")}
              type="number"
              onFocus={(event) => event.target.select()}
              onBlur={() => {
                const value = handlerAllowanceFormatted(
                  "transportAmount",
                  transportAmount
                );
                handlerEditAllowance({ name: "transportAmount", value });
              }}
              value={transportAmount}
              onChange={(e) =>
                this.setState({ transportAmount: e.target.value })
              }
            />
          </div>
        </td>
        <td hidden={!showNurseryBenefit}>
          <div className="cob-input-group">
            <input
              placeholder={t("common-messages.amount")}
              type="number"
              onFocus={(event) => event.target.select()}
              onBlur={() => {
                const value = handlerAllowanceFormatted(
                  "nurseryAmount",
                  nurseryAmount
                );
                handlerEditAllowance({ name: "nurseryAmount", value });
              }}
              value={nurseryAmount}
              onChange={(e) => this.setState({ nurseryAmount: e.target.value })}
            />
          </div>
        </td>
        <td className="center-content">
          <span>{totalAllowanceAmount}</span>
        </td>
      </tr>
    );
  }
}

AllowanceEmployeeRow.defaultProps = {
  showMealBenefit: false,
  showTransportBenefit: false,
  showNurseryBenefit: false,
};
AllowanceEmployeeRow.propTypes = {
  employee: PropTypes.object.isRequired,
  employeesItem: PropTypes.object.isRequired,
  showMealBenefit: PropTypes.bool,
  showTransportBenefit: PropTypes.bool,
  showNurseryBenefit: PropTypes.bool,
  handlerEditAllowance: PropTypes.func.isRequired,
  totalAllowanceAmount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  countryISO2Code: PropTypes.string.isRequired,
};

export default AllowanceEmployeeRow;
